import CapitalCallPortion from "./CapitalCallPortion";

export default CapitalCallPortion;
